import React, { useEffect, useRef, useState } from 'react'

import { CFormInput, CFormLabel } from '@coreui/react-pro'
import classNames from 'classnames'
import { ICON_EYE_NONE, ICON_EYE_OPEN } from 'utils/constants/images'

interface FormInputProps {
  label?: string
  type?: string
  value?: string
  placeholder?: string
  disabled?: boolean
  required?: boolean
  iconBefore?: any
  class?: string
  className?: string
  classNameContainer?: string
  isPassword?: boolean
  maxLength?: number
  invalid?: boolean
  autoComplete?: string
  resetPassword?: boolean
  onChange?: (value: string) => void
  validate?: (value: string) => string | undefined // Add validate prop with function type
  onPress?: () => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  onClick?: () => void
  autoFocus?: boolean
}

const FormInput: React.FC<FormInputProps> = ({
  label,
  type,
  value,
  placeholder,
  disabled,
  required,
  iconBefore,
  onChange,
  className,
  classNameContainer,
  isPassword,
  maxLength,
  invalid,
  onPress,
  autoComplete,
  resetPassword,
  onKeyDown,
  onClick,
  autoFocus = false,
}) => {
  const [typePassword, setTypePassword] = useState(true)
  const inputRef = useRef<HTMLInputElement>(null)
  const handleChangeIcon = () => {
    setTypePassword(!typePassword)
  }

  const handleOnChange = (value: string) => {
    if (maxLength && value.length > maxLength) {
      value = value.substring(0, maxLength)
    }
    onChange && onChange(value)
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && onPress) {
      event.preventDefault()
      onPress()
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      if (autoFocus && inputRef.current) {
        inputRef.current?.focus()
      } else if (inputRef.current) {
        inputRef.current?.blur()
      }
    }, 150)

    return () => clearTimeout(timer)
  }, [autoFocus])

  return (
    <div className={`form-input ${classNameContainer}`}>
      {label && <CFormLabel className="form-input-label">{label}</CFormLabel>}
      <div className="position-relative">
        {iconBefore && (
          <div className="position-absolute form-input-iconBefore">
            <img src={iconBefore} alt="" />
          </div>
        )}
        {isPassword ? (
          <>
            <CFormInput
              className={classNames(`mcs-input ${className}`)}
              type={typePassword ? 'password' : 'text'}
              value={value}
              placeholder={placeholder}
              disabled={disabled}
              required={required}
              invalid={invalid}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleOnChange(event.target.value)
              }
              onClick={onClick}
              onKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) =>
                onPress ? handleKeyPress(event) : {}
              }
              onKeyDown={onKeyDown}
              ref={inputRef}
              autoComplete={autoComplete}
            />
            {!resetPassword && (
              <div className="position-absolute form-input-iconAfter">
                <img
                  src={typePassword ? ICON_EYE_OPEN : ICON_EYE_NONE}
                  alt=""
                  onClick={handleChangeIcon}
                />
              </div>
            )}
          </>
        ) : (
          <CFormInput
            className={classNames(`mcs-input ${className}`)}
            type={type}
            value={value}
            placeholder={placeholder}
            disabled={disabled}
            required={required}
            invalid={invalid}
            autoComplete={autoComplete}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              handleOnChange(event.target.value)
            }
            onKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) =>
              onPress ? handleKeyPress(event) : {}
            }
            onKeyDown={onKeyDown}
            ref={inputRef}
          />
        )}
      </div>
    </div>
  )
}

export default FormInput
